module.exports = __webpack_public_path__ + "img/hero_s@2x.56d0a806.webp";